module.exports = __webpack_public_path__ + "static/media/team-1.10406a00.jpg";